import TierApi from '@apis/tier/TierApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetTierHistoryParams } from '@models/tier';

const tierQueries = createQueryKeys('tier', {
    tier: () => ({
        queryKey: ['tier'],
        queryFn: () => TierApi.getTier(),
    }),
    benefits: () => ({
        queryKey: ['benefits'],
        queryFn: () => TierApi.getTierBenefits(),
    }),
    history: (params: Omit<GetTierHistoryParams, 'page'>) => ({
        queryKey: [params],
    }),
    cycles: () => ({
        queryKey: ['cycles'],
        queryFn: () => TierApi.getTierCalculationCycles(),
    }),
});

export default tierQueries;
